var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19 15.962-6-5.987 6-5.988-3-2.993-6 5.987L4 .994 1 3.987l6 5.988-6 5.987 3 2.993 6-5.987 6 5.987 3-2.993Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
};
export default SvgCross;